import { resolveBrand } from '@pokerroom/branding';

export const brand = resolveBrand(__DEPLOY_ENV__, __BRAND_PROFILE__);
